import { render, staticRenderFns } from "./WatchersList.vue?vue&type=template&id=1c18c5a9&"
import script from "./WatchersList.vue?vue&type=script&lang=js&"
export * from "./WatchersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports